/**
 * @param {HTMLElement} scope context in which to operate
 * @return {void}
 */
export default function clickRelay(scope = document) {
  const triggers = [].slice.call(scope.querySelectorAll('[data-relay]'));

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      event.preventDefault();

      const target = scope.getElementById(trigger.dataset.relay);

      // trigger click
      target.click();
    });
  });
}



// WEBPACK FOOTER //
// ./assets/js/components/clickRelay.js